import React, { useEffect } from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, IconButton } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';

interface ModalTitleProps {
  children?: React.ReactNode
  onClose?: () => void;
  inlineTitle?: boolean
  id?: string | null
}

export const ModalTitle = ({ 
  children, 
  onClose,
  inlineTitle = false,
  id = null
}: ModalTitleProps) => {

  useEffect(() => {
    if (onClose) {
      const onPressESC = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          onClose()
        }
      }

      document.addEventListener("keydown", onPressESC, false);
      return () => {
        document.removeEventListener("keydown", onPressESC, false);
      }  
    }
  }, [onClose])


  if (inlineTitle) {
    return (
      <DialogTitle
        id={id || undefined}
        sx={{
        padding: "24px 22px"
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center"
          }}>
          <Box sx={{
            flexGrow: 1
          }} >{children}</Box>
          <Box>
            <Button
              sx={{whiteSpace: "nowrap"}}
              variant="contained"
              startIcon={<ChevronLeftIcon sx={{color: '#ffffff'}}  />}
              onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </DialogTitle>
    );
  }



  return (
    <DialogTitle id={id || undefined}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center"
        }}>
        <Box sx={{
          flexGrow: 1
        }} >{children}</Box>
        <Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    </DialogTitle>
  );
}